/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { createContext } from 'react';
import PropTypes from 'prop-types';

/**
 * The GMail auth scope context
 * @export
 */
const GoogleAuthScopeContext = createContext({
    isLoading: false,
    hasScopeBeenApproved: null,
    setHasScopeBeenApproved: null,
});

GoogleAuthScopeContext.Provider.propTypes = {
    value: PropTypes.shape({
        isLoading: PropTypes.bool,
        hasScopeBeenApproved: PropTypes.bool,
        setHasScopeBeenApproved: PropTypes.func,
    }),
};

export default GoogleAuthScopeContext;
